// Adds 'gchoice--checked' class to Radio and Checkbox input wrappers

function init() {
  // Add a listener to each input
  document.querySelectorAll('.gfield_radio .gfield-choice-input, .gfield_checkbox .gfield-choice-input').forEach(input => {
    input.addEventListener('change', function() {
      styleChoiceGroup(this.closest('.gfield_radio, .gfield_checkbox'));
    });
    
    toggleChecked(input);
  });

  document.querySelectorAll('.gfield_radio').forEach(grp => styleRadioGroup(grp));
}

function styleChoiceGroup(choiceGroupEl) {
  choiceGroupEl.querySelectorAll('.gfield-choice-input').forEach(toggleChecked);
}

function toggleChecked(input) {
  input.closest('.gchoice').classList.toggle('gchoice--checked', input.matches(':checked'));
}

export default { init };